module.exports = __webpack_public_path__ + "static/media/brown.54c1ab78.svg";